import { CheckOutlined, CloseOutlined, QuestionOutlined } from "@ant-design/icons";
import { Tag } from "antd";

function ConsentTag({ isConsent, children }) {
  if (isConsent === null || isConsent === undefined) {
    return (
      <Tag color="gold" icon={<QuestionOutlined />}>
        {children}
      </Tag>
    );
  }
  return (
    <Tag
      color={isConsent ? "green" : "red"}
      icon={isConsent ? <CheckOutlined /> : <CloseOutlined />}
    >
      {children}
    </Tag>
  );
}

export default ConsentTag;
